import { useState } from 'react'
import { Constant } from '.'

const saveUser = (data: any) => {
  return localStorage.setItem('shareBook-user', JSON.stringify(data))
}

const saveDeviceToken = (data: any) => {
  return localStorage.setItem('userDeviceToken', JSON.stringify(data))
}

const removeUser = () => {
  return localStorage.removeItem('shareBook-user')
}
const removeDeviceToken = () => {
  return localStorage.removeItem('userDeviceToken')
}
const getDeviceToken = () => {
  const deviceToken = localStorage.getItem('userDeviceToken')
  return deviceToken ? JSON.parse(deviceToken) : null
}

const useCheckWidth = () => {
  const [width, setWidth] = useState(window.innerWidth)

  const handleResize = () => setWidth(window.innerWidth)
  window.addEventListener('resize', handleResize)

  return width
}

const getUser = () => {
  const user = localStorage.getItem('shareBook-user')
  return user ? JSON.parse(user) : null
}

const generatePassword = () => {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let password = ''

  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length)
    password += characters[randomIndex]
  }

  return password
}

function isValidVideo(base64UrlOrUrl?: string): boolean {
  const allowedExtensions =
    Constant.videoValidationConfig.videoValidationExtensions

  if (base64UrlOrUrl?.startsWith('data:video/')) {
    const mimeMatch = base64UrlOrUrl.match(/data:video\/(\w+);base64,/)
    const mimeExtension = mimeMatch ? mimeMatch[1].toLowerCase() : ''
    return allowedExtensions.includes(mimeExtension)
  } else {
    const extension = base64UrlOrUrl?.split('.').pop()?.toLowerCase()
    return extension ? allowedExtensions.includes(extension) : false
  }
}

const convertDateTime = (dateStr: string, timeStr: string) => {
  const [hours, minutes] = timeStr.split(':')
  const [time, period] = minutes.split(' ')
  let hourIn24: number = parseInt(hours, 10)
  if (period === 'PM' && hourIn24 !== 12) {
    hourIn24 += 12
  } else if (period === 'AM' && hourIn24 === 12) {
    hourIn24 = 0
  }
  const dateTimeStr = `${dateStr} ${String(hourIn24).padStart(
    2,
    '0',
  )}:${time.padStart(2, '0')}:00`
  return dateTimeStr
}

export default {
  saveUser,
  removeUser,
  getUser,
  generatePassword,
  isValidVideo,
  convertDateTime,
  useCheckWidth,
  saveDeviceToken,
  removeDeviceToken,
  getDeviceToken,
}
